export const AR_PROSE: Record<string, string> = {
  overview:
    "بي إس ميت عمليتان وخادم وسائط. الـ API والـ WebSocket على أصل واحد، وعميل المتصفح على أصل آخر، وخادم SFU مبني على mediasoup ينقل الصوت والفيديو. كل ما يلي هو الحد الفاصل بينها.\n\nكل ما يحدث قبل الاجتماع (تسجيل الدخول، إنشاء غرفة، الجدولة، الدعوة) هو REST. وكل ما يحدث داخل الاجتماع هو اتصال WebSocket واحد. لا استطلاع دوري، ولا قناة ثانية.",
  "section.auth.title": "المصادقة",
  "section.auth.intro":
    "ثلاث بيانات اعتماد بثلاثة أعمار. رمز الوصول هو JWT قصير العمر يُرسَل بترويسة `Authorization: Bearer`. ورمز التحديث معتم، يدور مع كل استعمال، ولا يُخزَّن إلا كتجزئة بمفتاح. وتقديم رمز سبق إنفاقه يُخرج الجلسة كلها، ذلك الجهاز وكل رمز في سلسلته، لأن رمزًا استُعمل مرتين له حاملان وأنت واحد منهما فقط. أما الطلبان المتسابقان بالرمز نفسه، وهو ما تفعله نافذتان مفتوحتان، فيُسمح بهما لثوانٍ بعد الدوران بدل معاقبتهما. أما رمز الانضمام فتصدره خدمة مدمجة لأحد مستخدميها، وهو صالح لغرفة واحدة لخمس دقائق.\n\nالضيوف لا يقدمون أي بيانات اعتماد. يرسلون اسمًا على المقبس، وإعدادات الغرفة تقرر الباقي.",
  "POST /api/auth/register": "إنشاء حساب.",
  "POST /api/auth/login": "تحويل بريد وكلمة مرور إلى جلسة.",
  "POST /api/auth/refresh": "تدوير رمز التحديث.",
  "POST /api/auth/refresh#note": "الرمز المقدَّم يتوقف عن العمل لحظة عودة هذا الرد.",
  "POST /api/auth/logout": "إبطال جلسة جهاز واحد.",
  "GET /api/auth/me": "الحساب الذي سجل الدخول.",
  "PATCH /api/auth/me": "تغيير الاسم المعروض أو الصورة.",
  "PATCH /api/auth/me#note": "المفتاح الغائب يترك الحقل كما هو، والمفتاح الصريح يستبدله.",
  "POST /api/auth/password": "تغيير كلمة المرور.",
  "POST /api/auth/password#note": "يخرج من كل الأجهزة الأخرى.",
  "GET /api/auth/sessions": "الأجهزة التي سجل هذا الحساب الدخول عليها.",
  "DELETE /api/auth/sessions": "الخروج من كل مكان آخر.",
  "DELETE /api/auth/sessions/:familyId": "الخروج من جهاز واحد.",
  "section.rooms.title": "الغرف",
  "section.rooms.intro":
    "الغرفة هي النصف الدائم من الاجتماع: رمز ثابت، ومالك، ومجموعة مفاتيح. تعيش أطول من أي مكالمة، فيستطيع فريق أن يحفظ واحدة ويستعملها كل أسبوع. والرمز هو مسار الـ URL كله، ولهذا يسجل العميل `/:slug` كآخر مسار لديه.",
  "GET /api/rooms": "الغرف التي تملكها.",
  "POST /api/rooms": "إنشاء غرفة.",
  "GET /api/rooms/:slug/preview": "ما يحق لشاشة الانضمام أن تعرفه قبل أن يسجل أحد الدخول.",
  "GET /api/rooms/:slug/preview#note": "لا يقول شيئًا عمن في الداخل، عن قصد.",
  "GET /api/rooms/:slug": "غرفة واحدة بإعداداتها.",
  "PATCH /api/rooms/:id": "تغيير اسم غرفة أو إعداداتها.",
  "PATCH /api/rooms/:id#note": "الغرفة الحية تلتزم بالتغيير في الحال.",
  "DELETE /api/rooms/:id": "حذف غرفة.",
  "DELETE /api/rooms/:id#note": "حذف ناعم، حتى لا يُعاد إصدار رمز أبدًا.",
  "GET /api/rooms/:id/participants": "من في المكالمة الآن.",
  "section.meetings.title": "الاجتماعات والدعوات",
  "section.meetings.intro":
    "الاجتماع حدث مجدول يشير إلى غرفة. الأوقات لحظات بصيغة RFC 3339 ومعها منطقة IANA الزمنية للمنظِّم، لأن «كل ثلاثاء الساعة 09:00 في بروكسل» ليس فارقًا ثابتًا عن UTC.\n\nكل مدعو يحصل على رابط برمز خاص به، فيصبح القبول والاعتذار منسوبين إلى صاحبهما دون مطالبة أحد بتسجيل الدخول. والرمز يعود إلى المنظِّم وحده.",
  "GET /api/meetings": "اجتماعاتك، وتلك التي دُعيت إليها.",
  "GET /api/meetings#note": "يُحدَّد نطاقه بـ ?from= و ?to=.",
  "POST /api/meetings": "جدولة اجتماع.",
  "POST /api/meetings#note": "ينشئ غرفة ما لم يسمِّ roomId غرفة تملكها.",
  "GET /api/meetings/:id": "اجتماع واحد.",
  "PATCH /api/meetings/:id": "تعديل اجتماع.",
  "DELETE /api/meetings/:id": "إلغاء اجتماع.",
  "DELETE /api/meetings/:id#note": "الحالة تتغير والسجل يبقى، ليُقال للمدعو إنه أُلغي.",
  "POST /api/meetings/:id/invites": "دعوة عناوين.",
  "DELETE /api/meetings/:id/invites/:inviteId": "سحب دعوة.",
  "GET /api/invites/:token": "قراءة دعوة.",
  "POST /api/invites/:token/respond": "قبول أو اعتذار.",
  "section.boards.title": "العرض",
  "section.boards.intro":
    "الرفع يرد بمجرد وصول الملف، والسبورة عندها في حالة `converting`. الصفحات تصل لاحقًا عبر المقبس، لأن معالجة مئتي شريحة تستغرق دقائق ولا ينبغي لطلب أن يبقى مفتوحًا كل هذا.\n\nتتحول المستندات إلى شرائح webp عبر libreoffice و poppler و cwebp. أما الصور فتُرمَّز مباشرة. والسبورة البيضاء الفارغة لا تحتاج أيًا منها.",
  "POST /api/rooms/:slug/boards": "رفع مستند أو صور، أو فتح سبورة بيضاء فارغة.",
  "POST /api/rooms/:slug/boards#note": "مرِّر ?socket= لتصلك board:progress على ذلك الاتصال.",
  "GET /api/rooms/:slug/boards/hash/:hash":
    "السبورة التي أنشأها هذا الاجتماع من الملف نفسه، إن وُجدت.",
  "GET /api/rooms/:slug/boards/hash/:hash#note":
    "hash هو SHA-256 للملف بأحرف سداسية عشرية صغيرة. اسأل قبل الرفع: النتيجة الموجبة سبورة تُفتح بدل ميغابايتات تُرسل ومستند يُحوَّل مرة أخرى. الخادم يحسب بصمة ما يصله فعلاً، فرفع ملف يملكه أصلاً يعيد السبورة نفسها كذلك.",
  "GET /api/boards/:id": "سبورة وصفحاتها.",
  "DELETE /api/boards/:id": "حذف سبورة وملفاتها.",
  "GET /cdn/boards/:boardId/:page": "شريحة واحدة بعد المعالجة.",
  "section.meta.title": "هذه النسخة وطبقة الوسائط",
  "section.meta.intro":
    "ما يسمح به هذا النشر، وخوادم ICE التي تحتاجها المكالمة. بيانات اعتماد ICE قصيرة العمر بحكم التصميم: تحمل انتهاءها معها، ويتحقق منها المُرحِّل دون أن يتقاسم مع هذا الخادم أي حالة لكل مستخدم.",
  "GET /healthz": "الحياة. يرد 503 حين تتعذر قاعدة البيانات.",
  "GET /api/config": "الميزات والحدود.",
  "GET /api/ice": "خوادم STUN و TURN.",
  "GET /api/version": "الإصدار وما هو مُهيَّأ.",
  "section.socket.title": "بروتوكول WebSocket",
  "section.socket.intro":
    'شكل واحد للإطار في الاتجاهين: `{ "t": event, "d": payload }`. الإطار الذي ينتظر ردًا يضيف `"i"`، وهو عدد صحيح يعيده الخادم في رده؛ والرد الفاشل يحمل `"e": true` ويصبح `d` فيه `{ code, message }`. هذا كل التأطير.\n\nاتصل بـ `wss://<api-origin>/ws`، وأرسل `session:auth` أولًا، وانتظر `session:ready` قبل أي شيء آخر. والاتصال الذي لا يصادق أبدًا يُقطع بعد عشر ثوان.',
  "event.session:auth": "الإطار الأول. الرمز يسجل دخولك، والاسم يدخلك ضيفًا.",
  "event.session:ping": "فحص للحياة، يُرد عليه بـ session:pong.",
  "event.session:ready": "تمت المصادقة. لا يُقبل شيء قبل هذا.",
  "event.session:closed": "لماذا يوشك الاتصال أن ينتهي. و`fatal` تعني أن إعادة المحاولة لن تنفع.",
  "event.room:join": "الدخول إلى غرفة. يُرد عليه بـ room:state، أو يضعك في غرفة الانتظار.",
  "event.room:leave": "المغادرة.",
  "event.room:state": "كل ما يلزم لرسم الغرفة، في إطار واحد.",
  "event.room:settings": "مضيف غيّر شيئًا.",
  "event.room:ended": "المضيف أنهى الاجتماع للجميع.",
  "event.participant:joined": "أحدهم وصل.",
  "event.participant:updated": "تغير ميكروفونه أو كاميرته أو يده أو دوره.",
  "event.participant:left": "أحدهم غادر.",
  "event.media:state": "ما تنشره أنت.",
  "event.media:hand": "رفع اليد أو خفضها.",
  "event.lobby:waiting": "من يطرق الباب. يُرسل إلى المضيفين والمضيفين المشاركين.",
  "event.lobby:admitted": "سُمح لك بالدخول؛ أعد إرسال room:join.",
  "event.lobby:denied": "لم يُسمح لك بالدخول.",
  "event.sfu:capabilities": "قدرات RTP للموجِّه.",
  "event.sfu:transport-create": "اتجاه واحد من وسائطك.",
  "event.sfu:transport-connect": "إتمام مصافحة DTLS.",
  "event.sfu:produce": "بدء نشر مسار.",
  "event.sfu:consume-many": "الاشتراك في مجموعة كاملة دفعة واحدة، لكل منها طبقتها الأولى.",
  "event.sfu:consumers-resume": "تشغيل كل ما أنشأه consume-many.",
  "event.sfu:consumer-layers": "إعادة توجيه الاشتراكات بعد تغير التخطيط.",
  "event.producer:added": "أحدهم بدأ مسارًا. استهلكه.",
  "event.producer:removed": "توقف مسار.",
  "event.chat:send": "إرسال رسالة إلى الغرفة.",
  "event.chat:message": "تُعاد إلى الجميع، والمرسل منهم.",
  "event.board:open": "وضع سبورة على شاشة الجميع.",
  "event.board:page": "الجميع يتبع مقدم العرض.",
  "event.board:stroke": "عملية رسم واحدة، بإحداثيات من 0 إلى 1 على الصفحة.",
  "event.board:progress": "تقدم التحويل، لمن رفع الملف وحده.",
  "event.board:ready": "اكتملت معالجة الصفحات.",
  "event.mod:role": "ترقية أو تنزيل. الرتبة تحدد ما هو مسموح.",
  "event.mod:mute": "كتم شخص واحد.",
  "event.mod:remove": "إخراج شخص واحد.",
  "event.mod:lobby-admit": "السماح لأحدهم بالدخول.",
  "event.mod:end": "إنهاء الاجتماع للجميع. للمضيف وحده.",
  "code.Opening a connection as a guest": "فتح اتصال بصفة ضيف",
  "section.integration.title": "دمج بي إس ميت",
  "section.integration.intro":
    'هكذا يدمج بي إس تشات وبي إس كاليندر بي إس ميت. مفتاح الخدمة يصادق الخادم المتصل لا مستخدمًا، ويُرسل في ترويسة `X-BSMeet-Key`. أنشئ واحدًا على مضيف الـ API بالأمر `bsmeet-server --mint-key <service> "<label>"`؛ يُطبع النص الأصلي مرة واحدة ولا يُخزَّن إلا كتجزئة.\n\nهذا النموذج لا يشترط عمدًا أن يكون لمستخدميك حسابات في بي إس ميت. تُنشأ الغرفة مقابل عنوان، ويُهيَّأ حساب لذلك العنوان إن لم يكن له حساب، فتكون الغرف ملكًا لصاحبها لا لخدمتك. ورمز الانضمام يُدخل أحد مستخدميك غرفة واحدة، باسم تختاره أنت، لخمس دقائق، ودون أي حساب.',
  "POST /api/service/rooms": "إنشاء غرفة بالنيابة عن أحد مستخدميك.",
  "GET /api/service/rooms/:slug": "البحث عن غرفة.",
  "POST /api/service/meetings": "جدولة اجتماع من تقويمك.",
  "POST /api/service/meetings#note":
    "لا يتكرر أثره مع externalId نفسه، فإعادة إرسال الـ webhook لا تنشئ اجتماعين.",
  "GET /api/service/meetings/:externalId": "إيجاد اجتماع بمعرِّفك أنت.",
  "DELETE /api/service/meetings/:externalId": "إلغاؤه.",
  "POST /api/service/join-tokens": "إدخال أحد مستخدميك غرفة واحدة.",
  "POST /api/service/join-tokens#note":
    "خمس دقائق، وغرفة واحدة، وجمهور منفصل حتى لا يُستعمل كتسجيل دخول. ويعمل في غرفة أُوقف فيها الضيوف، لأن مفتاح خدمتك هو الضمان. صاحب دور cohost يدخل مباشرة، أما guest أو presenter فينتظر إن كان للغرفة قاعة انتظار، لأن ضمانك لشخص ليس موافقة المضيف على استقباله.",
  "code.Putting a join button in a BS Chat conversation": "وضع زر انضمام داخل محادثة بي إس تشات",
  errors:
    'كل رد ليس من فئة 2xx يحمل البنية نفسها:\n\n    { "error": { "code": "room_full", "message": "This meeting is full", "fields": { } } }\n\nطابق على `code` فهو ثابت. أما `message` فمكتوب ليقرأه إنسان وقد يتغير؛ و`fields` لا يظهر إلا مع أخطاء التحقق، ويربط اسم كل حقل برسالته. ورفض المقبس يستعمل `code` و`message` نفسيهما داخل إطار الرد.',
};
